import { Config } from "~/constants/configuration_provider";

export const getMacInstallCommand = (
  tokenValue: string,
) => `export MONDOO_REGISTRATION_TOKEN='${tokenValue}'
curl -sSL https://${Config.VITE_INSTALL_HOST}/sh | bash -s -- -i pkg -s enable -u enable -t $MONDOO_REGISTRATION_TOKEN`;
